import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import ToastMessage from "../../utils/mui/righttoptoast";
import dayjs from "dayjs";

export default function ProviderModal({ open,setFetchedData, setProviderModalOpen, selectedCard, onClose = () => {} }) {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [saved, setSaved] = useState(false);
 const [alertmessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [toastopen, setOpen] = useState(false);
    const [isLoading,setIsLoading]=useState(false)
  const handlealert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  
  const practiseid = window.getPracticeId();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200) {
      const data = response.data;
      setProviders([...data]);

      // Match selectedCard?.linked_provider with API data
      if (selectedCard?.linked_provider) {
        const matchedProvider = data.find(
          (p) => p.providername === selectedCard.linked_provider
        );
        if (matchedProvider) {
          setSelectedProvider(matchedProvider);
        }
      }
    } else {
      setProviders([]);
    }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchData();
      setSaved(false);
      setSelectedProvider(null);
    }
  }, [open]);

  if (!open) return null;

  const handleSave = async() => {
    console.log("Selected Provider:", selectedProvider);
    try {
      setIsLoading(true)

const payload={
      "appointment_id": selectedCard?.appointmentid,
   appointment_date: dayjs(selectedCard?.startDate).format("YYYY-MM-DD"),
       
     'linked_provider':selectedProvider?.providername
}
   
       const response = await api.put(`/v1/${practiseid}/checkin/patient/${selectedCard?.patientid}/update-data`,payload )
     if(response.status==200){
        setAlertMessage('Provider Changed Successfully');
      setSeverity('success');
      setOpen(true);
   setFetchedData(prevData =>
  prevData.map(item =>
    item.id === selectedCard.id
      ? { ...item, linked_provider: selectedProvider.providername} // update only room_no
      : item // keep others unchanged
  )
);
setTimeout(() => {
  setOpen(false)
setProviderModalOpen(false)
}, 1200);

     }else{
        setAlertMessage(response?.message||'Something Went Wrong');
      setSeverity('info');
      setOpen(true);
     }
    } catch (error) {
      console.log(error)
        setAlertMessage('Something Went Wrong');
      setSeverity('error');
      setOpen(true);
    }finally{
setIsLoading(false)
    }

  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />

      <div className="relative bg-white w-[92%] max-w-[520px] rounded-2xl shadow-2xl ring-1 ring-black/5 overflow-hidden">
        <div className="px-4 py-2 pt-3 border-b flex items-center justify-between">
          <h3 className="text-[18px] font-font1 font-semibold text-[#111827]">Select Provider</h3>
          <button onClick={onClose} aria-label="Close" className="p-1">
            <FontAwesomeIcon icon={faXmark} color="#9CA3AF" />
          </button>
        </div>

        <div className="px-5 py-4 max-h-[45vh] overflow-y-auto custom-scrollbar">
          {loading ? (
            <div className="space-y-2">
              {[...Array(5)].map((_, idx) => (
                <div key={idx} className="h-10 bg-gray-200 rounded animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="flex flex-wrap gap-3">
              {providers.map((provider) => {
                const isActive = selectedProvider?.providerid === provider?.providerid;
                return (
                  <button
                    key={provider.providerid}
                    type="button"
                    onClick={() => setSelectedProvider(provider)}
                    className={
                      isActive
                        ? "px-4 py-2 rounded-full text-[13px] font-medium font-font1 bg-[#E88D67] text-white border border-[#E88D67] shadow-[#E88D6733]"
                        : "px-4 py-2 rounded-full text-[13px] font-medium font-font1 bg-[#F9FAFB] text-[#1F2937] border border-[#E5E7EB]"
                    }
                  >
                    {provider.providername}
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="px-5 py-4 border-t bg-[#F9FAFB] flex items-center gap-4">
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-xl bg-white border border-[#E5E7EB] text-[#111827] text-sm hover:bg-gray-50"
          >
            Cancel
          </button>

          {!saved && (
            <button
              onClick={handleSave}
              disabled={!selectedProvider}
              className={`w-full py-2.5 rounded-xl ${
                selectedProvider ? "bg-[#111827] text-white hover:opacity-95" : "bg-gray-300 text-gray-600 cursor-not-allowed"
              } text-sm`}
            >
              Update
            </button>
          )}
        </div>
      </div>
         <Backdrop
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
              }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
               <ToastMessage message={alertmessage} severity={severity} open={toastopen} handleClose={handlealert} />
    </div>
  );
}
